import React from "react";

import { ConfirmDialog } from "@/components";

import { ConfirmDialogContext } from "./confirm-dialog-context";

export interface IConfirmDialogContext {
  openDialog: (
    title: string,
    description: string,
    onConfirm: () => void,
    onCancel?: () => void
  ) => void;
}

export const ConfirmDialogProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [open, setOpen] = React.useState(false);
  const [dialogProps, setDialogProps] = React.useState<{
    title: string;
    description: string;
    onConfirm: () => void;
    onCancel?: () => void;
  }>({
    title: "",
    description: "",
    onConfirm: () => {},
  });

  const openDialog = React.useCallback(
    (
      title: string,
      description: string,
      onConfirm: () => void,
      onCancel?: () => void
    ) => {
      setDialogProps({ title, description, onConfirm, onCancel });
      setOpen(true);
    },
    []
  );

  const closeDialog = () => setOpen(false);

  return (
    <ConfirmDialogContext.Provider value={{ openDialog }}>
      {children}
      {open && (
        <ConfirmDialog
          title={dialogProps.title}
          description={dialogProps.description}
          onConfirm={() => {
            dialogProps.onConfirm();
            closeDialog();
          }}
          onCancel={() => {
            dialogProps.onCancel?.();
            closeDialog();
          }}
        />
      )}
    </ConfirmDialogContext.Provider>
  );
};
